import { withAlertHandler } from 'entoro-shared';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import OfferActionDialog from '../../OfferOverview/OfferActionDialog';
import { wefunderOfferRequestInformationMutation } from '../../../apollo';

class OfferAction extends Component {
  state = {
    open: true,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  request = async ({ message }) => {
    const {
      client,
      handleSnackbarError,
      setSnackbarMessage,
      offerId,
      refetchQueries,
    } = this.props;

    const { mutate } = client;

    const variables = {
      offerId,
      message,
    };

    try {
      await mutate({
        mutation: wefunderOfferRequestInformationMutation,
        variables,
        refetchQueries,
      });

      this.handleClose();
      setSnackbarMessage(
        'Thank You for your interest. Someone will contact you shortly'
      );
    } catch (error) {
      this.handleClose();
      handleSnackbarError(error);
    }
  };

  requestMsg = async ({ message }) => {
    const {
      client,
      handleSnackbarError,
      setSnackbarMessage,
      offerId,
      refetchQueries,
    } = this.props;

    const { mutate } = client;

    const variables = {
      offerId,
      message,
      investorWefunderId: sessionStorage.getItem('weFunderUserId'),
    };

    try {
      await mutate({
        mutation: wefunderOfferRequestInformationMutation,
        variables,
        refetchQueries,
      });

      this.handleClose();
      setSnackbarMessage(
        'Thank You for your interest. Someone will contact you shortly'
      );
    } catch (error) {
      this.handleClose();
      handleSnackbarError(error);
    }
  };

  render() {
    const { open } = this.state;
    const { title, dialogBody, enableMessage, wefunderRequestform } =
      this.props;

    return (
      <Fragment>
        <OfferActionDialog
          open={open && wefunderRequestform}
          handleClose={this.handleClose}
          request={this.requestMsg}
          title={title}
          dialogBody={dialogBody}
          enableMessage={enableMessage}
        />
      </Fragment>
    );
  }
}

OfferAction.propTypes = {
  client: PropTypes.object.isRequired,
  handleSnackbarError: PropTypes.func.isRequired,
  setSnackbarMessage: PropTypes.func.isRequired,
  offerId: PropTypes.string.isRequired,
  mutation: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  dialogBody: PropTypes.string.isRequired,
  refetchQueries: PropTypes.array,
  enableMessage: PropTypes.bool.isRequired,
  linkForm: PropTypes.bool,
};

OfferAction.defaultProps = {
  refetchQueries: [],
};

export default connect()(withApollo(withAlertHandler(OfferAction)));



// WEBPACK FOOTER //
// ./src/components/WefunderOffer/WefunderRequestInformationButton/RequestInformationAction.js